import { useSyncExternalStore } from 'react';
import { createPersistentStore } from './storeUtils';

export interface MobileShellState {
  launcherOpen: boolean;
  searchOpen: boolean;
}

const store = createPersistentStore<MobileShellState>({
  launcherOpen: false,
  searchOpen: false,
});

export const openLauncher = () => store.set((s) => ({ ...s, launcherOpen: true }));
export const closeLauncher = () => store.set((s) => ({ ...s, launcherOpen: false }));
export const toggleLauncher = () => store.set((s) => ({ ...s, launcherOpen: !s.launcherOpen }));
export const setLauncherOpen = (open: boolean) => store.set((s) => ({ ...s, launcherOpen: open }));

export const openSearch = () => store.set((s) => ({ ...s, searchOpen: true }));
export const closeSearch = () => store.set((s) => ({ ...s, searchOpen: false }));
export const toggleSearch = () => store.set((s) => ({ ...s, searchOpen: !s.searchOpen }));
export const setSearchOpen = (open: boolean) => store.set((s) => ({ ...s, searchOpen: open }));

export function useMobileShell() {
  const state = useSyncExternalStore(
    store.subscribe,
    store.getSnapshot,
    store.getSnapshot
  );

  return {
    ...state,
    openLauncher,
    closeLauncher,
    toggleLauncher,
    setLauncherOpen,
    openSearch,
    closeSearch,
    toggleSearch,
    setSearchOpen,
  };
}

export function useMobileShellStore<T = MobileShellState>(selector?: (state: MobileShellState) => T): T {
  const state = useSyncExternalStore(
    store.subscribe,
    store.getSnapshot,
    store.getSnapshot
  );
  return selector ? selector(state) : (state as unknown as T);
}

